import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _Object$freeze from "@babel/runtime-corejs2/core-js/object/freeze";
import _Set from "@babel/runtime-corejs2/core-js/set";
/**
 * Redux resources reducer relies on actions metadata to keep track of request
 * state.
 */
import includes from 'lodash/includes';
import { DEFAULT_LABEL, FETCH_LIST_START, FETCH_LIST_SUCCESS, FETCH_LIST_FAILURE, FETCH_ONE_START, FETCH_ONE_SUCCESS, FETCH_ONE_FAILURE, CREATE_ONE_START, CREATE_ONE_SUCCESS, CREATE_ONE_FAILURE, UPDATE_ONE_START, UPDATE_ONE_SUCCESS, UPDATE_ONE_FAILURE, PATCH_ONE_START, PATCH_ONE_SUCCESS, PATCH_ONE_FAILURE, DELETE_ONE_START, DELETE_ONE_SUCCESS, DELETE_ONE_FAILURE, HEAD_START, HEAD_SUCCESS, HEAD_FAILURE, POST_START, POST_SUCCESS, POST_FAILURE, PUT_START, PUT_SUCCESS, PUT_FAILURE, PATCH_START, PATCH_SUCCESS, PATCH_FAILURE, INVALIDATE } from './constants';
import { removeOne, appendOne, matches } from './helpers';
var DEFAULT_RESOURCE_STATE = {
  // List of successful requests (by label)
  isLoaded: [],
  // List of failed requests (by label)
  isFailure: [],
  // List of requests that are in progress (by label)
  isFetching: [],
  // list of requests that should refetch data (by label)
  isToRefetch: [],
  // List of successful requests (by label)
  isLoadedOne: [],
  // List of failed requests (by label)
  isFailureOne: [],
  // List of requests that are in progress (by label)
  isFetchingOne: [],
  // list of requests that should refetch data (by label)
  isToRefetchOne: [],
  isCreatingOne: [],
  isUpdatingOne: [],
  isPatchingOne: [],
  isDeletingOne: [],
  isPosting: [],
  isPutting: [],
  isPatching: [],
  isDeleting: [],
  // list of head requests that are in progress (by label)
  isHeading: [],
  // list of failed head requests
  isHeadFailure: []
};

/**
 * Update a part of the state associated with resource
 */
var updateStateForResource = function updateStateForResource(resource, label, oldState, newResourceState) {
  var resourceOldState = oldState[resource] || DEFAULT_RESOURCE_STATE;
  return _objectSpread(_objectSpread({}, oldState), {}, _defineProperty({}, resource, _objectSpread(_objectSpread({}, resourceOldState), typeof newResourceState === 'function' ? newResourceState(resourceOldState) : newResourceState)));
};
var frozenEmptyObj = _Object$freeze({});

// eslint-disable-next-line default-param-last
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  // only interpret actions with resource and type
  if (!action || !action.meta || !action.meta.resource || !action.meta.type) {
    return state;
  }
  var response = action.payload && action.payload.error && action.payload.error.response;
  var responseStatus;
  if (response) {
    responseStatus = response.status;
  }
  var resourceName = action.meta.resource;
  var label = action.meta.label;
  switch (action.meta.type) {
    case FETCH_LIST_START:
      // Increment the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isFetching: appendOne(curr.isFetching, label)
        };
      });
    case FETCH_LIST_SUCCESS:
      // Decrement the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isFetching: removeOne(curr.isFetching, label),
          isLoaded: includes(curr.isLoaded, label) ? curr.isLoaded : appendOne(curr.isLoaded, label),
          isFailure: removeOne(curr.isFailure, {
            label: label
          }),
          isToRefetch: removeOne(curr.isToRefetch, label)
        };
      });
    case FETCH_LIST_FAILURE:
      // Decrement the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isFetching: removeOne(curr.isFetching, label),
          isFailure: matches(curr.isFailure, {
            label: label
          }) ? curr.isFailure : appendOne(curr.isFailure, _objectSpread({
            label: label
          }, responseStatus ? {
            status: responseStatus
          } : frozenEmptyObj)),
          isToRefetch: removeOne(curr.isToRefetch, label)
        };
      });
    case FETCH_ONE_START:
      // Increment the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isFetchingOne: appendOne(curr.isFetchingOne, label)
        };
      });
    case FETCH_ONE_SUCCESS:
      // Decrement the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isFetchingOne: removeOne(curr.isFetchingOne, label),
          isLoadedOne: includes(curr.isLoadedOne, label) ? curr.isLoadedOne : appendOne(curr.isLoadedOne, label),
          isFailureOne: removeOne(curr.isFailureOne, {
            label: label
          }),
          isToRefetchOne: removeOne(curr.isToRefetchOne, label)
        };
      });
    case FETCH_ONE_FAILURE:
      // Decrement the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isFetchingOne: removeOne(curr.isFetchingOne, label),
          isFailureOne: matches(curr.isFailureOne, {
            label: label
          }) ? curr.isFailureOne : appendOne(curr.isFailureOne, _objectSpread({
            label: label
          }, responseStatus ? {
            status: responseStatus
          } : frozenEmptyObj)),
          isToRefetchOne: removeOne(curr.isToRefetchOne, label)
        };
      });
    case CREATE_ONE_START:
      // Increment the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isCreatingOne: appendOne(curr.isCreatingOne, label)
        };
      });
    case CREATE_ONE_SUCCESS:
    case CREATE_ONE_FAILURE:
      // Decrement the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isCreatingOne: removeOne(curr.isCreatingOne, label)
        };
      });
    case UPDATE_ONE_START:
      // Increment the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isUpdatingOne: appendOne(curr.isUpdatingOne, label)
        };
      });
    case UPDATE_ONE_SUCCESS:
    case UPDATE_ONE_FAILURE:
      // Decrement the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isUpdatingOne: removeOne(curr.isUpdatingOne, label)
        };
      });
    case PATCH_ONE_START:
      // Increment the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isPatchingOne: appendOne(curr.isPatchingOne, label)
        };
      });
    case PATCH_ONE_SUCCESS:
    case PATCH_ONE_FAILURE:
      // Decrement the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isPatchingOne: removeOne(curr.isPatchingOne, label)
        };
      });
    case POST_START:
      // Increment the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isPosting: appendOne(curr.isPosting, label)
        };
      });
    case POST_SUCCESS:
    case POST_FAILURE:
      // Decrement the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isPosting: removeOne(curr.isPosting, label)
        };
      });
    case PUT_START:
      // Increment the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isPutting: appendOne(curr.isPutting, label)
        };
      });
    case PUT_SUCCESS:
    case PUT_FAILURE:
      // Decrement the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isPutting: removeOne(curr.isPutting, label)
        };
      });
    case PATCH_START:
      // Increment the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isPatching: appendOne(curr.isPatching, label)
        };
      });
    case PATCH_SUCCESS:
    case PATCH_FAILURE:
      // Decrement the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isPatching: removeOne(curr.isPatching, label)
        };
      });
    case HEAD_START:
      // Increment the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isHeading: appendOne(curr.isHeading, label)
        };
      });
    case HEAD_SUCCESS:
      // Decrement the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isHeading: removeOne(curr.isHeading, label),
          isHeadFailure: matches(curr.isHeadFailure, {
            label: label
          }) ? removeOne(curr.isHeadFailure, {
            label: label
          }) : curr.isHeadFailure
        };
      });
    case HEAD_FAILURE:
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isHeadFailure: matches(curr.isHeadFailure, {
            label: label
          }) ? curr.isHeadFailure : appendOne(curr.isHeadFailure, _objectSpread({
            label: label
          }, responseStatus ? {
            status: responseStatus
          } : frozenEmptyObj)),
          // Decrement the loader
          isHeading: removeOne(curr.isHeading, label)
        };
      });
    case DELETE_ONE_START:
      // Increment the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isDeletingOne: appendOne(curr.isDeletingOne, label)
        };
      });
    case DELETE_ONE_SUCCESS:
    case DELETE_ONE_FAILURE:
      // Decrement the loader
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isDeletingOne: removeOne(curr.isDeletingOne, label)
        };
      });
    case INVALIDATE:
      // Append every isLoaded/isLoadedOne values into isToRefetch/isToRefetchOne
      return updateStateForResource(resourceName, label, state, function (curr) {
        return {
          isToRefetch: _toConsumableArray(new _Set([].concat(curr.isToRefetch, curr.isLoaded, curr.isFailure.map(function (resource) {
            return resource.label;
          })))),
          isToRefetchOne: _toConsumableArray(new _Set([].concat(curr.isToRefetchOne, curr.isLoadedOne, curr.isFailureOne.map(function (resource) {
            return resource.label;
          }))))
        };
      });
    default:
      return state;
  }
});
var EMPTY_OBJECT = {};
var selectRaw = function selectRaw(state) {
  return state.gandiReduxResource || EMPTY_OBJECT;
};
var selectRawResource = function selectRawResource(state, resourceName) {
  return selectRaw(state)[resourceName] || DEFAULT_RESOURCE_STATE;
};
export var selectIsLoadedResource = function selectIsLoadedResource(state, _ref) {
  var resource = _ref.resource,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? DEFAULT_LABEL : _ref$label;
  return includes(selectRawResource(state, resource).isLoaded, label);
};
export var selectIsFailureResource = function selectIsFailureResource(state, _ref2) {
  var resource = _ref2.resource,
    _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? DEFAULT_LABEL : _ref2$label,
    status = _ref2.status;
  return matches(selectRawResource(state, resource).isFailure, {
    label: label,
    status: status
  });
};
export var selectIsFetchingResource = function selectIsFetchingResource(state, _ref3) {
  var resource = _ref3.resource,
    _ref3$label = _ref3.label,
    label = _ref3$label === void 0 ? DEFAULT_LABEL : _ref3$label;
  return includes(selectRawResource(state, resource).isFetching, label);
};
export var selectIsToRefetchResource = function selectIsToRefetchResource(state, _ref4) {
  var resource = _ref4.resource,
    _ref4$label = _ref4.label,
    label = _ref4$label === void 0 ? DEFAULT_LABEL : _ref4$label;
  return includes(selectRawResource(state, resource).isToRefetch, label);
};
export var selectIsLoadedOneResource = function selectIsLoadedOneResource(state, _ref5) {
  var resource = _ref5.resource,
    _ref5$label = _ref5.label,
    label = _ref5$label === void 0 ? DEFAULT_LABEL : _ref5$label;
  return includes(selectRawResource(state, resource).isLoadedOne, label);
};
export var selectIsFailureOneResource = function selectIsFailureOneResource(state, _ref6) {
  var resource = _ref6.resource,
    _ref6$label = _ref6.label,
    label = _ref6$label === void 0 ? DEFAULT_LABEL : _ref6$label,
    status = _ref6.status;
  return matches(selectRawResource(state, resource).isFailureOne, {
    label: label,
    status: status
  });
};
export var selectIsFetchingOneResource = function selectIsFetchingOneResource(state, _ref7) {
  var resource = _ref7.resource,
    _ref7$label = _ref7.label,
    label = _ref7$label === void 0 ? DEFAULT_LABEL : _ref7$label;
  return includes(selectRawResource(state, resource).isFetchingOne, label);
};
export var selectIsToRefetchOneResource = function selectIsToRefetchOneResource(state, _ref8) {
  var resource = _ref8.resource,
    _ref8$label = _ref8.label,
    label = _ref8$label === void 0 ? DEFAULT_LABEL : _ref8$label;
  return includes(selectRawResource(state, resource).isToRefetchOne, label);
};
export var selectIsCreatingOneResource = function selectIsCreatingOneResource(state, _ref9) {
  var resource = _ref9.resource,
    _ref9$label = _ref9.label,
    label = _ref9$label === void 0 ? DEFAULT_LABEL : _ref9$label;
  return includes(selectRawResource(state, resource).isCreatingOne, label);
};
export var selectIsUpdatingOneResource = function selectIsUpdatingOneResource(state, _ref10) {
  var resource = _ref10.resource,
    _ref10$label = _ref10.label,
    label = _ref10$label === void 0 ? DEFAULT_LABEL : _ref10$label;
  return includes(selectRawResource(state, resource).isUpdatingOne, label);
};
export var selectIsPatchingOneResource = function selectIsPatchingOneResource(state, _ref11) {
  var resource = _ref11.resource,
    _ref11$label = _ref11.label,
    label = _ref11$label === void 0 ? DEFAULT_LABEL : _ref11$label;
  return includes(selectRawResource(state, resource).isPatchingOne, label);
};
export var selectIsDeletingOneResource = function selectIsDeletingOneResource(state, _ref12) {
  var resource = _ref12.resource,
    _ref12$label = _ref12.label,
    label = _ref12$label === void 0 ? DEFAULT_LABEL : _ref12$label;
  return includes(selectRawResource(state, resource).isDeletingOne, label);
};
export var selectIsHeadingResource = function selectIsHeadingResource(state, _ref13) {
  var resource = _ref13.resource,
    _ref13$label = _ref13.label,
    label = _ref13$label === void 0 ? DEFAULT_LABEL : _ref13$label;
  return includes(selectRawResource(state, resource).isHeading, label);
};
export var selectIsHeadFailureResource = function selectIsHeadFailureResource(state, _ref14) {
  var resource = _ref14.resource,
    _ref14$label = _ref14.label,
    label = _ref14$label === void 0 ? DEFAULT_LABEL : _ref14$label;
  return matches(selectRawResource(state, resource).isHeadFailure, {
    label: label
  });
};
export var selectIsPostingResource = function selectIsPostingResource(state, _ref15) {
  var resource = _ref15.resource,
    _ref15$label = _ref15.label,
    label = _ref15$label === void 0 ? DEFAULT_LABEL : _ref15$label;
  return includes(selectRawResource(state, resource).isPosting, label);
};
export var selectIsPuttingResource = function selectIsPuttingResource(state, _ref16) {
  var resource = _ref16.resource,
    _ref16$label = _ref16.label,
    label = _ref16$label === void 0 ? DEFAULT_LABEL : _ref16$label;
  return includes(selectRawResource(state, resource).isPutting, label);
};
export var selectIsPatchingResource = function selectIsPatchingResource(state, _ref17) {
  var resource = _ref17.resource,
    _ref17$label = _ref17.label,
    label = _ref17$label === void 0 ? DEFAULT_LABEL : _ref17$label;
  return includes(selectRawResource(state, resource).isPatching, label);
};
export var selectShouldFetch = function selectShouldFetch(state, options) {
  var isLoaded = selectIsLoadedResource(state, options);
  var isFailure = selectIsFailureResource(state, options);
  var isToRefetch = selectIsToRefetchResource(state, options);
  var isFetching = selectIsFetchingResource(state, options);
  return (!isLoaded && !isFailure || isToRefetch) && !isFetching;
};
export var selectShouldFetchOne = function selectShouldFetchOne(state, options) {
  var isLoaded = selectIsLoadedOneResource(state, options);
  var isFailure = selectIsFailureOneResource(state, options);
  var isToRefetch = selectIsToRefetchOneResource(state, options);
  var isFetching = selectIsFetchingOneResource(state, options);
  return (!isLoaded && !isFailure || isToRefetch) && !isFetching;
};